import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Field } from 'redux-form';

import AutosuggestField from 'components/fields/AutosuggestField';

import * as validate from 'utils/validate';
import formatPrescriberName from 'utils/formatPrescriberName';

import OrderInformationSectionTitle from '../OrderInformationSectionTitle';

const OrderInformationPrescriberSelection = ({
  Prescriber,
  onAddButtonClick,
  change,
  disabled,
  ...fields
}) => (
  <Fragment>
    <OrderInformationSectionTitle title="Prescriber" />
    <Field
      key={Prescriber.map(item => item.ID).join(',')}
      id="Prescriber Name"
      name="Prescriber Name"
      component={AutosuggestField}
      {...(fields['Primary Insurance ID'] && fields['Primary Insurance ID'].input.value)
        ? { validate: [validate.required] }
        : {}
      }
      placeholder="-Select Prescriber-"
      fullWidth
      renderSuggestionContent={(suggestion) => {
        const name = formatPrescriberName(suggestion);
        return suggestion.NPI ? `${name} (NPI: ${suggestion.NPI})` : name;
      }}
      onSuggestionSelected={(suggestion) => {
        const name = formatPrescriberName(suggestion);
        change('Prescriber ID', suggestion.ID);
        change('Selected Prescriber Name', name);
        return name;
      }}
      fetchSuggestions={({ value, offset }) => (new Promise((resolve) => {
        if (offset === 0) {
          if (value.length > 0) {
            resolve(Prescriber
              .filter(item => formatPrescriberName(item).toLowerCase()
                .indexOf(value.toLowerCase()) !== -1));
          } else {
            resolve(Prescriber);
          }
        } else {
          resolve([]);
        }
      }))}
      onListAdornmentClick={onAddButtonClick}
      listAdornmentText="Add From List"
      disabled={disabled}
    />
  </Fragment>
);

OrderInformationPrescriberSelection.propTypes = {
  Prescriber: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
    'First Name': PropTypes.string,
    'Last Name': PropTypes.string,
    'Name Prefix': PropTypes.string,
    'Name Suffix': PropTypes.string,
    Credential: PropTypes.string,
    NPI: PropTypes.string,
  })),
  change: PropTypes.func.isRequired,
  onAddButtonClick: PropTypes.func,
};

OrderInformationPrescriberSelection.defaultProps = {
  Prescriber: [],
  onAddButtonClick: null,
};

export default OrderInformationPrescriberSelection;



// WEBPACK FOOTER //
// ./src/components/workflow/OrderInformation/OrderInformationPrescriber/OrderInformationPrescriberSelection.js